import { createAsyncActionConstants } from 'utilities/util';

export const TYPES = {
    LOGIN: createAsyncActionConstants('LOGIN'),
    TOKEN: createAsyncActionConstants('TOKEN')
}